<template>
  <div>
    <!-- Templates Selection (inside of Modal) -->
    <div
      class="template-wrapper"
      v-for="(template, index) in filteredTemplates"
      :key="index"
      @click="updateEditorContent(template)"
    >
      <div class="mb-4">
        <div class="mb-2 font-weight-bolder">
          <h6
            class="badge badge-primary text-wrap"
          >{{ template.name || template.subject || 'No Template Name' }}</h6>
          <br />
          <strong class="text">"{{ template.subject || 'No Template Subject'}}"</strong>
          <br />
          <br />
        </div>
        <div class="font-weight-light template-html-body" v-html="template.body" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TEMPLATE_SET_CURRENT } from "@/store/types";

export default {
  props: {
    tab: String
  },
  methods: {
    updateEditorContent(template) {
      this.$eventHub.$emit("update-content", template);
      this.$store.commit(TEMPLATE_SET_CURRENT, template);
    }
  },
  computed: {
    ...mapGetters(["getTemplates"]),
    filteredTemplates() {
      if (!this.tab) {
        return this.getTemplates;
      } else {
        return this.getTemplates.filter(template =>
          template.tags.includes(this.tab)
        );
      }
    }
  },
  data() {
    return {
      name: "message-templates"
    };
  }
};
</script>

<style lang="scss">
.template-html-body {
  p {
    margin-bottom: 0px;
  }
}
</style>